import { Provider } from '@angular/core';

import { PayslipsUseCasesImpl } from '@app/domain/use-cases/ptrab/payslips/payslips.use-cases';
import { PAYSLIPS_USE_CASES } from '@app/domain/use-cases/ptrab/payslips/payslips.use-cases.contract';

export const payslipsUseCasesProvider: Provider = {
  provide: PAYSLIPS_USE_CASES,
  useClass: PayslipsUseCasesImpl
};
